<template>
    <div>
        <component
            :is="`section-${item.key}`"
            v-for="(item, index) in value"
            :id="`content-builder-item-${index}`"
            :key="index"
            :value="item.value"
            class="content_section"
        />
    </div>
</template>

<script>
import Header from './sections/Header';
import Text from './sections/Text';
import Image from './sections/Image';
import Video from './sections/Video';
import Gallery from './sections/Gallery';
import Pdf from './sections/Pdf';
import Audio from './sections/Audio';
import Form from './sections/Form';
import Double from './sections/Double';

export default {
    components: {
        'section-header': Header,
        'section-text': Text,
        'section-image': Image,
        'section-video': Video,
        'section-gallery': Gallery,
        'section-pdf': Pdf,
        'section-audio': Audio,
        'section-form': Form,
        'section-double': Double
    },

    props: {
        value: {
            type: Array,
            required: true
        }
    }
};
</script>
